(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/eurojackpot/views/pages/fractiongames-page.js') >= 0) return;  svs.modules.push('/modules/eurojackpot/views/pages/fractiongames-page.js');
(function(svs, Handlebars) {
_svs=window.svs=window.svs||{};
_svs.eurojackpot=_svs.eurojackpot||{};
_svs.eurojackpot.templates=_svs.eurojackpot.templates||{};
svs.eurojackpot.templates.fractiongames_page = Handlebars.template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div id=\"ngFractiongamesRegion\" class=\"eurojackpot-fractiongames-container\"></div>\n";
},"useData":true});
Handlebars.partials['svs-eurojackpot-fractiongames_page'] = svs.eurojackpot.templates.fractiongames_page;
})(svs, Handlebars);


 })(window);